let tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const tutorialPlayers = [];

const tutorialListSection = $('#tutorials-list-section');
const tutorialMenuCards = tutorialListSection.find('.tutorial-menu-card');
const tutorialVideoCards = tutorialListSection.find('.tutorial-video-card');
const tutorialProgressParent = tutorialListSection.find('.tutorials-progress-parent');
const tutorialProgressInnerParent = tutorialProgressParent.find('.tutorials-progress-bar-parent');
const tutorialProgressInner = tutorialProgressParent.find('.tutorials-progress-bar');
const tutorialsCount = tutorialVideoCards.length;
const tutorialProgressCountPlacer = tutorialListSection.find('.tutorials-progress-count-placer');
const tutorialProgressCount = tutorialProgressCountPlacer.find('#count');
let activeTutorial = 0;
let switchBlocked = false;
const tutorialCardOffset = isDesktop() ? 2.938 : isTablet() ? 2.604 : 2.778;

const progressMap = {};

function updateProgress() {
  const progressBar = $('.tutorials-progress-bar-inner');
  const watchProgressStorage = sessionStorage.getItem('tutorialWatchProgress');
  const watchProgress = watchProgressStorage ? Number(watchProgressStorage) : 0;
  gsap.to(progressBar, {
    width: `${25 * watchProgress}%`,
    duration: 0.33,
    ease: 'pageInEasing',
  });
  tutorialProgressCount.text(watchProgress);
}

const addVideoControl = () => {
  tutorialVideoCards.each(function (index) {
    const card = $(this);
    const videoCover = card.find('.tutorial-cover-image');
    const playIcon = card.find('.tutorial-cover-play-icon');
    const cardOverflow = card.find('.tutorial-video-card-overflow');
    const coverCard = card.find('.toturial-cover-card');
    const cardImage = card.find('.tutorial-cover-card-image');
    const playerEl = card.find('.player');
    const dataUrl = playerEl.attr('data-url') || '';
    const videoId = (dataUrl.split('v=')[1] || '').split('&')[0] || '';
    const playerId = `player-${index + 1}`;
    const openedCardOverflowWidth = pxToVw(cardOverflow.outerWidth());
    const openedCardOverflowHeight = pxToVw(cardOverflow.outerHeight());
    const closedCardOverflowWidth = pxToVw(cardImage.outerWidth(true));
    const cardOverflowPadding = pxToVw(parseFloat(coverCard.css('padding-top')) || 0);

    playerEl.attr('id', playerId);
    function toggleCard(state) {
      gsap.to(cardOverflow, {
        width: state ? `${openedCardOverflowWidth}vw` : `${closedCardOverflowWidth + cardOverflowPadding * 2}vw`,
        height: state
          ? `${openedCardOverflowHeight}vw`
          : `${closedCardOverflowWidth + cardOverflowPadding * 2}vw`,
        duration: 1,
        ease: 'pageInEasing',
        overwrite: 'auto',
      });
    }

    tutorialPlayers[index] = {
      index,
      playerId,
      videoCover,
      playIcon,
      cardOverflow,
      toggleCard,
      videoId,
      player: null,
      created: false,
      firstViewingKey: `firstViewingTutorial${playerId}`,
      createPlayer: function () {
        if (this.player) return;

        tutorialPlayers.forEach((p, idx) => {
          if (!p) return;
          if (p.player && idx !== this.index) {
            p.destroyPlayer();
          }
        });

        this.player = new YT.Player(this.playerId, {
          height: '360',
          width: '640',
          videoId: this.videoId,
          playerVars: {
            autoplay: 0,
            rel: 0,
          },
          events: {
            onReady: (event) => {
              const saved = progressMap[this.index];
              if (typeof saved === 'number' && !isNaN(saved) && saved > 0) {
                try {
                  event.target.seekTo(saved, true);
                } catch (e) {}
              }
              if (!sessionStorage.getItem(this.firstViewingKey)) {
                sessionStorage.setItem(this.firstViewingKey, 'true');
              }
            },
            onStateChange: (event) => {
              switch (event.data) {
                case YT.PlayerState.PLAYING:
                  try {
                    this.toggleCard(false);
                  } catch (e) {}
                  break;
                case YT.PlayerState.PAUSED:
                  try {
                    this.toggleCard(true);
                  } catch (e) {}
                  break;
                case YT.PlayerState.ENDED:
                  this.videoCover.fadeIn(300);
                  this.playIcon.fadeIn(300);
                  if (!cardVisible) {
                    try {
                      this.toggleCard(true);
                    } catch (e) {}
                  }
                  const firstViewing = sessionStorage.getItem(this.firstViewingKey);
                  if (firstViewing === 'true') {
                    const watchProgressStorage = sessionStorage.getItem('tutorialWatchProgress');
                    const watchProgress = watchProgressStorage ? Number(watchProgressStorage) : 0;
                    sessionStorage.setItem('tutorialWatchProgress', watchProgress + 1);
                    sessionStorage.setItem(this.firstViewingKey, 'false');
                    updateProgress();
                  }
                  break;
              }
            },
          },
        });

        this.created = true;
      },
      destroyPlayer: function () {
        if (this.player) {
          try {
            if (typeof this.player.getCurrentTime === 'function') {
              const time = this.player.getCurrentTime();
              if (!isNaN(time)) progressMap[this.index] = time;
            }
          } catch (e) {}
          try {
            this.player.destroy();
          } catch (e) {}
        }
        this.player = null;
        this.created = false;
        try {
          this.videoCover.fadeIn(0);
          this.playIcon.fadeIn(0);
        } catch (e) {}
        try {
          this.toggleCard(true);
        } catch (e) {}
      },
    };
    videoCover.on('click', () => {
      if (switchBlocked) return;
      if (index !== activeTutorial) return;
      const p = tutorialPlayers[index];
      if (!p) return;
      p.videoCover.fadeOut(300);
      p.playIcon.fadeOut(300);
      p.player.playVideo();
    });
  });
};

window.onYouTubeIframeAPIReady = function () {
  addVideoControl();
  tutorialPlayers[0].createPlayer();
};

const setTutorialsCards = () => {
  gsap.set(tutorialVideoCards, {
    top: (index) => {
      if (index == activeTutorial) {
        return `${2 * tutorialCardOffset}vw`;
      } else {
        return `${((index + activeTutorial) % 2) * tutorialCardOffset}vw`;
      }
    },
    scale: (index) => 1 - ((tutorialsCount - activeTutorial + index) % tutorialsCount) * 0.12,
    zIndex: (index) => 200 - ((tutorialsCount - activeTutorial + index) % tutorialsCount),
    opacity: 1,
  });
};

const changeTutorialsAnimation = (duration, to) => {
  if (activeTutorial != to) {
    const prevMenuCard = tutorialMenuCards.eq(activeTutorial);
    const nextMenuCard = tutorialMenuCards.eq((activeTutorial + 1) % tutorialsCount);

    gsap.fromTo(
      tutorialVideoCards,
      {
        top: (index) => {
          if (index == activeTutorial) {
            return `${2 * tutorialCardOffset}vw`;
          } else {
            return `${((index + activeTutorial) % 2) * tutorialCardOffset}vw`;
          }
        },
        scale: (index) => 1 - ((tutorialsCount - activeTutorial + index) % tutorialsCount) * 0.12,
        zIndex: (index) => 200 - ((tutorialsCount - activeTutorial + index) % tutorialsCount),
        opacity: 1,
        display: 'block',
      },
      {
        top: (index) => `${((tutorialsCount - 1 - index + activeTutorial) % tutorialsCount) * tutorialCardOffset}vw`,
        scale: (index) => {
          if (index == activeTutorial) {
            return 1.1;
          } else {
            return 1 - ((tutorialsCount - 1 - activeTutorial + index) % tutorialsCount) * 0.12;
          }
        },
        duration: duration,
        ease: 'pageInEasing',
        delay: (index) => ((tutorialsCount - activeTutorial + index) % tutorialsCount) * 0.033,
        onComplete: () => {
          activeTutorial = (activeTutorial + 1) % tutorialsCount;
          tutorialPlayers[activeTutorial].createPlayer();
          changeTutorialsAnimation(duration, to);
        },
      }
    );

    gsap.to(prevMenuCard, {
      opacity: 0.6,
      duration: duration,
      ease: 'pageinEasing',
    });
    gsap.to(nextMenuCard, {
      opacity: 1,
      duration: duration,
      ease: 'pageinEasing',
    });
    gsap.set(tutorialVideoCards.eq(activeTutorial), { display: 'none', delay: duration * 0.5 });
  } else {
    switchBlocked = false;
  }
};

const changeTutorial = (to) => {
  tutorialPlayers.forEach((p) => {
    if (p && p.player) {
      p.destroyPlayer();
    }
  });

  switchBlocked = true;
  const diff = (to - activeTutorial + tutorialsCount) % tutorialsCount;
  const duration = 0.633 / (diff);
  changeTutorialsAnimation(duration, to, diff);
};

const addTutorialControl = () => {
  tutorialMenuCards.on('click', function () {
    const index = $(this).index();
    if (!switchBlocked && index != activeTutorial) {
      changeTutorial(index);
    }
  });

  tutorialVideoCards.on('click', function () {
    const index = $(this).index();
    if (!switchBlocked && index != activeTutorial) {
      changeTutorial(index);
    }
  });
};

const progressBarIn = () => {
  const progressInTL = gsap.timeline({ paused: true });
  gsap.set([tutorialProgressParent, tutorialProgressInner, tutorialProgressCountPlacer], {
    clearProps: 'width',
  });

  const progressBarWidth = pxToVw(tutorialProgressParent.outerWidth());
  const progressBarHeight = pxToVw(tutorialProgressParent.outerHeight());
  const progressBarInnerWidth = pxToVw(tutorialProgressInner.outerWidth());
  const tutorialProgressCountWidth = pxToVw(tutorialProgressCountPlacer.outerWidth(true));

  gsap.set([tutorialProgressParent, tutorialProgressInner, tutorialProgressCountPlacer], {
    clearProps: 'width',
  });
  progressInTL.add(
    gsap.fromTo(
      tutorialProgressParent,
      {
        y: `${1.875 * 1.5 + progressBarHeight}vw`,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1.33,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  progressInTL.add(
    gsap.fromTo(
      tutorialProgressParent,
      {
        width: `${tutorialProgressCountWidth}vw`,
      },
      {
        width: `${progressBarWidth}vw`,
        duration: 1,
        ease: 'pageInEasing',
      }
    ),
    1
  );
  progressInTL.add(
    gsap.fromTo(
      tutorialProgressInner,
      {
        width: 0,
        opacity: 0,
      },
      {
        width: `${progressBarInnerWidth}vw`,
        opacity: 1,
        duration: 1,
        ease: 'pageInEasing',
      }
    ),
    1
  );
  if (!isDesktop()) {
    progressInTL.add(
      gsap.fromTo(
        tutorialProgressInnerParent,
        {
          width: 0,
          opacity: 0,
        },
        {
          width: `${progressBarInnerWidth}vw`,
          opacity: 1,
          duration: 1,
          ease: 'pageInEasing',
        }
      ),
      1
    );
  }

  ScrollTrigger.create({
    trigger: tutorialProgressParent,
    start: `top-=350% bottom`,
    end: 'bottom top',
    once: true,
    onEnter: () => {
      progressInTL.play();
    },
  });

  return progressInTL;
};

const addtutorialListIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #959698ff 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionTopperInTL = gsap.timeline({
    paused: true,
  });
  const sectionInTL = gsap.timeline({
    paused: true,
  });

  if (isDesktop()) {
    sectionTopperInTL.add(
      animateSectionTopperIn({
        sectionParent: tutorialListSection,
        gradientConfig: gradientConfig,
      }).play(),
      0
    );
  }

  tutorialMenuCards.each(function (index) {
    const toOpacity = index == 0 ? 1 : 0.6;
    sectionInTL.add(elementInAnimationYWOpacity($(this), '23.75vw', 0, toOpacity, 1).play(), 0.033 * index + 0.1);
  });
  tutorialVideoCards.each(function (index) {
    sectionInTL.add(
      elementInAnimationYWOpacity($(this), '13.75vw', 1, 1, 1).play(),
      (tutorialsCount - index - 1) * 0.066 + 0.1
    );
  });

  return [sectionTopperInTL, sectionInTL];
};

const initTutorialList = () => {
  setTutorialsCards(1);
  updateProgress();
  progressBarIn();
  addTutorialControl();

  if(isDesktop()){
    let [tutorialsTopperInTL, tutorialsListTL] = addtutorialListIn();
    $(window).on('deviceChange', function () {
      const topperProgress = tutorialsTopperInTL.progress();
      const listProgress = tutorialsListTL.progress();
      [tutorialsTopperInTL, tutorialsListTL] = addtutorialListIn();
      tutorialsTopperInTL.progress(topperProgress);
      tutorialsListTL.progress(listProgress);
    });
    ScrollTrigger.create({
      trigger: tutorialListSection,
      start: 'top top+=120%',
      end: 'top top',
      once: true,
      onUpdate: (self) => {
        tutorialsTopperInTL.progress(self.progress);
      },
    });
    ScrollTrigger.create({
      trigger: tutorialListSection,
      start: 'top top+=80%',
      end: 'top top',
      once: true,
      onEnter: () => {
        tutorialsListTL.play();
      },
    });
  }
}

/*
$(window).on('load', () => {
  initTutorialList();
});
*/

addSectionObserver(tutorialListSection,initTutorialList);